import { useState, useEffect } from "react";
import { Box, Typography } from "@mui/material";

export default function TextLabel({
    sx,
    title,
    variant,
    style,
    noWrap = false,
    color = "#1E1E1E",
    fontSize,
    fontWeight,
    fontColor,
    secondText,
    secondTextColor,
    secondFontWeight,
    marginTop,
    margin,
    textAlign,
    fontStyle,
    className,
    isIconStart,
    icon,
    textDecoration,
    isIconEnd,
    subText,
    subTextStyle,
    textColor,
    secondTextDecoration,
    cursor,
    padding,
    width,
    lineHeight,
    marginBottom,
    textTransform,
    onClick,
    component,
}) {
    const variantToFontSize = {
        h1: "40px",
        h2: "32px",
        h3: "30px",
        h4: "26px",
        h5: "24px",
        h6: "20px",
        subtitle1: "18px",
        subtitle2: "16px",
        body1: "14px",
        body2: "12px",
    };

    const [responsiveFontSize, setResponsiveFontSize] = useState(
        fontSize || variantToFontSize[variant]
    );

    useEffect(() => {
        const updateFontSizes = () => {
            const newVariantToFontSize = { ...variantToFontSize };
            if (window.innerWidth <= 600) {
                newVariantToFontSize.h1 = "30px";
                newVariantToFontSize.h2 = "20px";
                newVariantToFontSize.h3 = "24px";
                newVariantToFontSize.h4 = "22px";
                newVariantToFontSize.h5 = "20px";
                newVariantToFontSize.h6 = "18px";
                newVariantToFontSize.subtitle1 = "16px";
                newVariantToFontSize.subtitle2 = "14px";
                newVariantToFontSize.body1 = "12px";
                newVariantToFontSize.body2 = "12px";
            }
            setResponsiveFontSize(fontSize || newVariantToFontSize[variant]);
        };

        window.addEventListener("resize", updateFontSizes);
        updateFontSizes();
        return () => {
            window.removeEventListener("resize", updateFontSizes);
        };
    }, [fontSize, variant]);

    return (
        <Box fontWeight={fontWeight || "fontWeightBold"} width={width}>
            <Typography
                noWrap={noWrap}
                variant={variant || "subtitle2"}
                sx={{
                    textTransform: textTransform || "initial",
                    fontWeight: fontWeight || 400,
                    fontSize: color === "error" ? "12px" : fontSize || variantToFontSize.subtitle2,
                    // color: fontColor || color,
                    margin: margin || "0px",
                    marginTop: marginTop || "0px",
                    marginBottom: marginBottom || "0px",
                    textAlign: textAlign || "left",
                    fontStyle: fontStyle || "normal",
                    textDecoration: textDecoration || null,
                    cursor: cursor,
                    padding: padding,
                    ...sx, lineHeight: lineHeight,
                }}
                className={className}
                color={color === "error" ? '#FF0101' : color}
                onClick={onClick}
                component={component}
            >
                {isIconStart && icon}
                {title}{" "}
                {isIconEnd && icon}
                {secondText ? (
                    <span
                        style={{
                            color: secondTextColor || "#333",
                            textDecoration: secondTextDecoration,
                            fontWeight: secondFontWeight,
                        }}
                    >
                        {secondText}
                    </span>
                ) : null}
            </Typography>
            {subText ? (
                <Typography className={subTextStyle} color={textColor}>
                    {subText}
                </Typography>
            ) : null}
        </Box>
    );
}
